(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mirolyub-look-sequence"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mirolyub-look-sequence')) {
    customElements.define('mirolyub-look-sequence', class extends HTMLElement {
      connectedCallback() {
        this.frames = [...this.querySelectorAll('[data-frame]')];
        if (this.frames.length < 2) return;
        this.index = 0;
        this.manualPause = this.dataset.autoplay !== 'true';
        this.inView = false;
        this.hovered = false;
        this.focused = false;
        this.tempo = this.dataset.tempo.split(',').map(Number);
        this.phase = 0;
        this.settled = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.button = this.querySelector('[data-pause-button]');
        this.count = this.querySelector('.ml-sequence__count');
        this.announcement = this.querySelector('[role="status"]');
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        this.querySelector('.ml-sequence__controls').hidden = false;
        this.button.addEventListener('click', () => {
          if (this.settled) {
            this.frames[this.index].hidden = true;
            this.index = 0;
            this.frames[0].hidden = false;
            this.count.textContent = `01 / ${String(this.frames.length).padStart(2,'0')}`;
            this.phase = 0;
            this.settled = false;
            this.manualPause = false;
          } else this.manualPause = !this.manualPause;
          this.sync();
        }, options);
        this.querySelector('[data-next]').addEventListener('click', () => this.step(1, true), options);
        this.querySelector('[data-previous]').addEventListener('click', () => this.step(-1, true), options);
        this.addEventListener('pointerenter', () => {this.hovered = true;this.sync();}, options);
        this.addEventListener('pointerleave', () => {this.hovered = false;this.sync();}, options);
        this.addEventListener('focusin', () => {this.focused = true;this.sync();}, options);
        this.addEventListener('focusout', event => {if (!this.contains(event.relatedTarget)) {this.focused = false;this.sync();}}, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        this.frames.forEach(frame => frame.querySelector('img').addEventListener('load', () => this.sync(), options));
        this.observer = new IntersectionObserver(entries => {this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;this.sync();}, {threshold:.2});
        this.observer.observe(this);
        this.sync();
      }
      step(direction, manual = false) {
        if (manual) this.manualPause = true;
        const next = (this.index + direction + this.frames.length) % this.frames.length;
        const image = this.frames[next].querySelector('img');
        if (!image.complete || !image.naturalWidth) {this.sync();return;}
        this.frames[this.index].hidden = true;
        this.index = next;
        this.frames[this.index].hidden = false;
        this.count.textContent = `${String(this.index + 1).padStart(2,'0')} / ${String(this.frames.length).padStart(2,'0')}`;
        if (manual) {this.announcement.textContent = `${this.dataset.look} ${this.index + 1} / ${this.frames.length}`;this.sync();}
      }
      sync() {
        clearTimeout(this.timer);
        this.button.hidden = this.motion.matches;
        this.button.textContent = this.manualPause || this.settled || this.motion.matches ? this.dataset.play : this.dataset.pause;
        const ready = this.frames.every(frame => {const image = frame.querySelector('img');return image.complete && image.naturalWidth;});
        if (ready && this.inView && !this.manualPause && !this.settled && !this.motion.matches && !this.hovered && !this.focused && !document.hidden) this.timer = setTimeout(() => {
          this.step(1);
          this.phase += 1;
          if (this.phase === this.tempo.length) this.settled = true;
          this.sync();
        }, this.tempo[this.phase]);
      }
      disconnectedCallback() {clearTimeout(this.timer);this.observer?.disconnect();this.abort?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
